import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MapPin } from 'lucide-react';

export const LandingCouponsGrid = ({ allCoupons, showAllCoupons, setShowAllCoupons, onLogin }) => {
  if (allCoupons.length === 0) return null;

  return (
    <section className="py-12 md:py-16 bg-slate-100" data-testid="available-coupons-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-4">Cupons Disponíveis</h2>
          <p className="text-base text-slate-600">Encontre os melhores descontos perto de você</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {(showAllCoupons ? allCoupons : allCoupons.slice(0, 8)).map(coupon => (
            <Card key={coupon.coupon_id} className="bg-white border border-slate-200 shadow-sm hover:shadow-lg transition-all cursor-pointer"
              onClick={onLogin} data-testid={`coupon-card-${coupon.coupon_id}`}>
              {coupon.images?.length > 0 && (
                <div className="w-full aspect-[4/3] overflow-hidden rounded-t-lg">
                  <img src={coupon.images[0]} alt={coupon.title} className="w-full h-full object-cover" />
                </div>
              )}
              <CardContent className="pt-4">
                <div className="flex justify-between items-start mb-2">
                  <Badge className="bg-red-500 text-white border-0">{coupon.discount_percentage}% OFF</Badge>
                  <Badge className="bg-slate-100 text-slate-700 border-slate-200 text-xs">{coupon.category}</Badge>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-1">{coupon.title}</h3>
                <p className="text-sm text-slate-600 line-clamp-2 mb-2">{coupon.description}</p>
                <div className="flex items-center gap-1 text-xs text-slate-500"><MapPin className="h-3 w-3" /> {coupon.city}, {coupon.state}</div>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="text-center mt-8">
          {!showAllCoupons && allCoupons.length > 8 ? (
            <Button onClick={() => setShowAllCoupons(true)} variant="outline"
              className="border-slate-400 text-slate-700 hover:bg-slate-200 font-bold py-3 px-8 rounded-lg"
              data-testid="show-more-coupons-btn">
              Ver Mais Cupons
            </Button>
          ) : (
            <Button onClick={onLogin} className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-lg"
              data-testid="view-all-coupons-btn">
              Acessar Todos os Cupons
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};
